// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  admins: [],
}

export const mutations = {
  setAdmins(state, admins) {
    state.admins = admins
  },

  addAdmin(state, admin) {
    state.admins.push(admin)
  },

  editAdmin(state, admin) {
    const index = state.admins.findIndex(
      (element) => element.taff_admin_uuid === admin.taff_admin_uuid
    )
    if (index !== -1) {
      state.admins.splice(index, 1, admin)
    }
  },

  deleteAdmin(state, uuid) {
    const index = state.admins.findIndex((el) => el.taff_admin_uuid === uuid)
    if (index !== -1) {
      state.admins.splice(index, 1)
    }
  },
}

export const actions = {
  async fetchAdmins({ commit }) {
    const { data } = await mastertime.fetchAdmins()
    const admins = data.data

    commit('setAdmins', admins)
  },

  async addAdmin({ commit }, admin) {
    const { data } = await mastertime.addAdmin(admin)
    const newAdmin = data

    commit('addAdmin', newAdmin)
  },

  async editAdmin({ commit }, admin) {
    const { data } = await mastertime.editAdmin(admin)
    const adminUpdate = data

    commit('editAdmin', adminUpdate)
  },

  async deleteAdmin({ commit }, uuid) {
    await mastertime.deleteAdmin(uuid)

    commit('deleteAdmin', uuid)
  },
}
